var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export function merge(property, a, b) {
    var e_1, _a, e_2, _b;
    if (property.type === 'simple') {
        a[property.name] = b[property.name];
    }
    else if (property.type === 'nested') {
        try {
            for (var _c = __values(property.properties), _d = _c.next(); !_d.done; _d = _c.next()) {
                var nestedProperty = _d.value;
                merge(nestedProperty, a[property.name], b[property.name]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (property.type === 'array') {
        var arrayA = a[property.name];
        var arrayB = b[property.name];
        if (Array.isArray(arrayA) && Array.isArray(arrayB)) {
            var mergeKey_1 = property.mergeKey;
            if (mergeKey_1 !== undefined) {
                var _loop_1 = function (i) {
                    var e_3, _a;
                    var entry = arrayA[i];
                    var key = entry[mergeKey_1];
                    var matchingIndex = arrayB.findIndex(function (b) { return b[mergeKey_1] === key; });
                    // If no matching entry in the second array is found then remove the entry
                    if (matchingIndex < 0) {
                        arrayA.splice(i, 1);
                    }
                    else {
                        var entry2 = arrayB[matchingIndex];
                        try {
                            for (var _b = (e_3 = void 0, __values(property.properties)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var nestedProperty = _c.value;
                                merge(nestedProperty, entry, entry2);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        arrayB.splice(matchingIndex, 1);
                    }
                };
                // Use as key
                for (var i = 0; i < arrayA.length; ++i) {
                    _loop_1(i);
                }
                try {
                    // Push all entries that could not be matched
                    for (var arrayB_1 = __values(arrayB), arrayB_1_1 = arrayB_1.next(); !arrayB_1_1.done; arrayB_1_1 = arrayB_1.next()) {
                        var entry = arrayB_1_1.value;
                        arrayA.push(entry);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (arrayB_1_1 && !arrayB_1_1.done && (_b = arrayB_1.return)) _b.call(arrayB_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            else {
                while (arrayA.length > 0) {
                    arrayA.splice(0, 1);
                }
                arrayA.push.apply(arrayA, __spread(arrayB));
            }
        }
    }
}
//# sourceMappingURL=merge.js.map